import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar as CalendarIcon, Clock, Video, Users, CheckCircle2, AlertCircle, History } from 'lucide-react';
// Mock History Data
const mockHistory = [{
  id: '1',
  date: '12 Okt 2023',
  time: '10:00',
  type: 'Tatap Muka',
  status: 'Selesai',
  counselor: 'Bpk. Budi Santoso'
}, {
  id: '2',
  date: '05 Nov 2023',
  time: '13:30',
  type: 'Online Chat',
  status: 'Selesai',
  counselor: 'Ibu Siti Aminah'
}, {
  id: '3',
  date: '20 Nov 2023',
  time: '09:00',
  type: 'Tatap Muka',
  status: 'Menunggu',
  counselor: 'Bpk. Budi Santoso'
}];
export function Counseling() {
  const [activeTab, setActiveTab] = useState<'booking' | 'history'>('booking');
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    class: '',
    gender: '',
    serviceType: '',
    category: '',
    description: '',
    date: '',
    time: ''
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleNext = () => setStep(prev => prev + 1);
  const handleBack = () => setStep(prev => prev - 1);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStep(4); // Success step
  };
  // Simple mock calendar generation
  const generateDays = () => {
    const days = [];
    for (let i = 1; i <= 30; i++) {
      days.push(i);
    }
    return days;
  };
  const timeSlots = ['08:00', '09:00', '10:00', '11:00', '13:00', '14:00', '15:00'];
  return <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-278">
      <div className="text-center mb-10" data-id="element-279">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-280">
          Layanan Konseling
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-281">
          Jangan ragu untuk bercerita. Kami di sini untuk mendengarkan dan
          membantu menemukan solusi terbaik untukmu.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex justify-center mb-8" data-id="element-282">
        <div className="bg-gray-100 p-1 rounded-xl inline-flex" data-id="element-283">
          <button onClick={() => setActiveTab('booking')} className={`px-6 py-2.5 rounded-lg font-medium text-sm transition-all ${activeTab === 'booking' ? 'bg-white text-primary-dark shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-284">
            Booking Jadwal
          </button>
          <button onClick={() => setActiveTab('history')} className={`px-6 py-2.5 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${activeTab === 'history' ? 'bg-white text-primary-dark shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-285">
            <History size={16} data-id="element-286" /> Riwayat
          </button>
        </div>
      </div>

      {activeTab === 'booking' && <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-287">
          {/* Progress Bar */}
          {step < 4 && <div className="bg-gradient-to-r from-pink-50/50 to-blue-50/50 px-8 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-288">
              {[1, 2, 3].map(i => <div key={i} className="flex items-center" data-id="element-289">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${step >= i ? 'bg-gradient-to-r from-pink-400 to-blue-400 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-290">
                    {i}
                  </div>
                  <span className={`ml-2 text-sm font-medium hidden sm:block ${step >= i ? 'text-gray-800' : 'text-gray-400'}`} data-id="element-291">
                    {i === 1 ? 'Data Diri' : i === 2 ? 'Detail Masalah' : 'Jadwal'}
                  </span>
                  {i < 3 && <div className={`w-12 sm:w-24 h-1 mx-2 sm:mx-4 rounded ${step > i ? 'bg-gradient-to-r from-pink-400 to-blue-400' : 'bg-gray-200'}`} data-id="element-292"></div>}
                </div>)}
            </div>}

          <div className="p-6 md:p-10" data-id="element-293">
            {step === 1 && <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-294">
                <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-295">
                  Informasi Data Diri
                </h2>
                <div className="space-y-5" data-id="element-296">
                  <div data-id="element-297">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-298">
                      Nama Lengkap
                    </label>
                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" placeholder="Masukkan nama lengkapmu" data-id="element-299" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-300">
                    <div data-id="element-301">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-302">
                        Kelas
                      </label>
                      <select name="class" value={formData.class} onChange={handleInputChange} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all bg-white" data-id="element-303">
                        <option value="" data-id="element-304">Pilih Kelas</option>
                        <option value="X" data-id="element-305">Kelas X</option>
                        <option value="XI" data-id="element-306">Kelas XI</option>
                        <option value="XII" data-id="element-307">Kelas XII</option>
                      </select>
                    </div>
                    <div data-id="element-308">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-309">
                        Jenis Kelamin
                      </label>
                      <select name="gender" value={formData.gender} onChange={handleInputChange} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all bg-white" data-id="element-310">
                        <option value="" data-id="element-311">Pilih Jenis Kelamin</option>
                        <option value="L" data-id="element-312">Laki-laki</option>
                        <option value="P" data-id="element-313">Perempuan</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex justify-end" data-id="element-314">
                  <button onClick={handleNext} disabled={!formData.name || !formData.class || !formData.gender} className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-315">
                    Selanjutnya
                  </button>
                </div>
              </motion.div>}

            {step === 2 && <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-316">
                <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-317">
                  Detail Layanan & Masalah
                </h2>
                <div className="space-y-6" data-id="element-318">
                  <div data-id="element-319">
                    <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-320">
                      Pilih Jenis Layanan
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-321">
                      <label className={`cursor-pointer border-2 rounded-xl p-4 flex items-center gap-4 transition-all ${formData.serviceType === 'Online Chat' ? 'border-primary bg-primary-light/10' : 'border-gray-200 hover:border-primary-light'}`} data-id="element-322">
                        <input type="radio" name="serviceType" value="Online Chat" className="hidden" onChange={handleInputChange} data-id="element-323" />
                        <div className={`p-3 rounded-full ${formData.serviceType === 'Online Chat' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-324">
                          <Video size={24} data-id="element-325" />
                        </div>
                        <div data-id="element-326">
                          <h4 className="font-bold text-gray-800" data-id="element-327">
                            Online Chat
                          </h4>
                          <p className="text-xs text-gray-500" data-id="element-328">
                            Konseling via chat/video call
                          </p>
                        </div>
                      </label>
                      <label className={`cursor-pointer border-2 rounded-xl p-4 flex items-center gap-4 transition-all ${formData.serviceType === 'Tatap Muka' ? 'border-accent bg-accent-light/10' : 'border-gray-200 hover:border-accent-light'}`} data-id="element-329">
                        <input type="radio" name="serviceType" value="Tatap Muka" className="hidden" onChange={handleInputChange} data-id="element-330" />
                        <div className={`p-3 rounded-full ${formData.serviceType === 'Tatap Muka' ? 'bg-accent text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-331">
                          <Users size={24} data-id="element-332" />
                        </div>
                        <div data-id="element-333">
                          <h4 className="font-bold text-gray-800" data-id="element-334">
                            Tatap Muka
                          </h4>
                          <p className="text-xs text-gray-500" data-id="element-335">
                            Bertemu langsung di ruang BK
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div data-id="element-336">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-337">
                      Kategori Masalah
                    </label>
                    <select name="category" value={formData.category} onChange={handleInputChange} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all bg-white" data-id="element-338">
                      <option value="" data-id="element-339">Pilih Kategori</option>
                      <option value="Pribadi" data-id="element-340">
                        Pribadi (Kesehatan mental, emosi, dll)
                      </option>
                      <option value="Sosial" data-id="element-341">
                        Sosial (Pertemanan, keluarga, bullying)
                      </option>
                      <option value="Belajar" data-id="element-342">
                        Belajar (Motivasi, kesulitan belajar)
                      </option>
                      <option value="Karier" data-id="element-343">
                        Karier (Jurusan, cita-cita, kuliah)
                      </option>
                    </select>
                  </div>

                  <div data-id="element-344">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-345">
                      Ceritakan Sedikit Masalahmu (Opsional)
                    </label>
                    <textarea name="description" value={formData.description} onChange={handleInputChange} rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all resize-none" placeholder="Ceritakan apa yang sedang kamu rasakan atau pikirkan..." data-id="element-346"></textarea>
                    <p className="text-xs text-gray-500 mt-2 flex items-center gap-1" data-id="element-347">
                      <AlertCircle size={12} data-id="element-348" /> Tenang, ceritamu dijamin
                      kerahasiaannya.
                    </p>
                  </div>
                </div>
                <div className="mt-8 flex justify-between" data-id="element-349">
                  <button onClick={handleBack} className="text-gray-500 px-6 py-3 font-medium hover:text-gray-800 transition-colors" data-id="element-350">
                    Kembali
                  </button>
                  <button onClick={handleNext} disabled={!formData.serviceType || !formData.category} className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-351">
                    Selanjutnya
                  </button>
                </div>
              </motion.div>}

            {step === 3 && <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-352">
                <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-353">
                  Pilih Jadwal
                </h2>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-354">
                  {/* Custom Calendar */}
                  <div className="bg-white border border-gray-200 rounded-2xl p-5" data-id="element-355">
                    <div className="flex items-center justify-between mb-4" data-id="element-356">
                      <h3 className="font-bold text-gray-800 flex items-center gap-2" data-id="element-357">
                        <CalendarIcon size={18} className="text-primary" data-id="element-358" />{' '}
                        November 2023
                      </h3>
                      <div className="flex gap-2" data-id="element-359">
                        <button className="p-1 rounded hover:bg-gray-100" data-id="element-360">
                          &lt;
                        </button>
                        <button className="p-1 rounded hover:bg-gray-100" data-id="element-361">
                          &gt;
                        </button>
                      </div>
                    </div>
                    <div className="grid grid-cols-7 gap-1 text-center mb-2" data-id="element-362">
                      {['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'].map(day => <div key={day} className="text-xs font-semibold text-gray-400 py-1" data-id="element-363">
                            {day}
                          </div>)}
                    </div>
                    <div className="grid grid-cols-7 gap-1" data-id="element-364">
                      {/* Empty slots for offset */}
                      <div className="p-2" data-id="element-365"></div>
                      <div className="p-2" data-id="element-366"></div>
                      <div className="p-2" data-id="element-367"></div>

                      {generateDays().map(day => {
                  const dateStr = `2023-11-${day.toString().padStart(2, '0')}`;
                  const isSelected = formData.date === dateStr;
                  const isWeekend = (day + 3) % 7 === 0 || (day + 3) % 7 === 6; // Rough calculation for mock
                  return <button key={day} disabled={isWeekend} onClick={() => setFormData(prev => ({
                    ...prev,
                    date: dateStr
                  }))} className={`p-2 w-full aspect-square flex items-center justify-center rounded-full text-sm transition-all ${isSelected ? 'bg-primary text-white font-bold shadow-md' : isWeekend ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 hover:bg-primary-light/20'}`} data-id="element-368">
                            {day}
                          </button>;
                })}
                    </div>
                  </div>

                  {/* Time Slots */}
                  <div data-id="element-369">
                    <h3 className="font-bold text-gray-800 flex items-center gap-2 mb-4" data-id="element-370">
                      <Clock size={18} className="text-primary" data-id="element-371" /> Waktu
                      Tersedia
                    </h3>
                    {formData.date ? <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-372">
                        {timeSlots.map(time => <button key={time} onClick={() => setFormData(prev => ({
                  ...prev,
                  time
                }))} className={`py-3 px-4 rounded-xl text-sm font-medium border transition-all ${formData.time === time ? 'bg-primary text-white border-primary shadow-sm' : 'bg-white border-gray-200 text-gray-700 hover:border-primary-light'}`} data-id="element-373">
                            {time}
                          </button>)}
                      </div> : <div className="bg-gray-50 border border-dashed border-gray-200 rounded-xl p-8 text-center text-gray-500" data-id="element-374">
                        Silakan pilih tanggal terlebih dahulu
                      </div>}
                  </div>
                </div>

                <div className="mt-8 flex justify-between" data-id="element-375">
                  <button onClick={handleBack} className="text-gray-500 px-6 py-3 font-medium hover:text-gray-800 transition-colors" data-id="element-376">
                    Kembali
                  </button>
                  <button onClick={handleSubmit} disabled={!formData.date || !formData.time} className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-377">
                    Konfirmasi Booking
                  </button>
                </div>
              </motion.div>}

            {step === 4 && <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center py-10" data-id="element-378">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-379">
                  <CheckCircle2 size={40} className="text-green-500" data-id="element-380" />
                </div>
                <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-381">
                  Booking Berhasil! 🎉
                </h2>
                <p className="text-gray-600 mb-8 max-w-md mx-auto" data-id="element-382">
                  Jadwal konselingmu telah tercatat. Konselor akan segera
                  mengkonfirmasi sesimu. Sampai jumpa di hari H!
                </p>
                <div className="bg-gray-50 rounded-2xl p-6 max-w-sm mx-auto text-left mb-8 border border-gray-100" data-id="element-383">
                  <div className="grid grid-cols-2 gap-y-3 text-sm" data-id="element-384">
                    <div className="text-gray-500" data-id="element-385">Layanan</div>
                    <div className="font-semibold text-gray-800 text-right" data-id="element-386">
                      {formData.serviceType}
                    </div>
                    <div className="text-gray-500" data-id="element-387">Tanggal</div>
                    <div className="font-semibold text-gray-800 text-right" data-id="element-388">
                      {formData.date}
                    </div>
                    <div className="text-gray-500" data-id="element-389">Waktu</div>
                    <div className="font-semibold text-gray-800 text-right" data-id="element-390">
                      {formData.time}
                    </div>
                  </div>
                </div>
                <button onClick={() => {
            setStep(1);
            setActiveTab('history');
          }} className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-primary-dark transition-colors" data-id="element-391">
                  Lihat Riwayat
                </button>
              </motion.div>}
          </div>
        </div>}

      {activeTab === 'history' && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="space-y-4" data-id="element-392">
          {mockHistory.map(item => <div key={item.id} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-393">
              <div className="flex items-start gap-4" data-id="element-394">
                <div className={`p-3 rounded-xl ${item.type === 'Tatap Muka' ? 'bg-accent-light/20 text-accent-dark' : 'bg-primary-light/20 text-primary-dark'}`} data-id="element-395">
                  {item.type === 'Tatap Muka' ? <Users size={24} data-id="element-396" /> : <Video size={24} data-id="element-397" />}
                </div>
                <div data-id="element-398">
                  <h3 className="font-bold text-gray-800 text-lg" data-id="element-399">
                    {item.type}
                  </h3>
                  <p className="text-gray-500 text-sm flex items-center gap-2 mt-1" data-id="element-400">
                    <CalendarIcon size={14} data-id="element-401" /> {item.date} • <Clock size={14} data-id="element-402" />{' '}
                    {item.time}
                  </p>
                  <p className="text-gray-600 text-sm mt-2" data-id="element-403">
                    Konselor: {item.counselor}
                  </p>
                </div>
              </div>
              <div className={`px-4 py-1.5 rounded-full text-sm font-medium ${item.status === 'Selesai' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-404">
                {item.status}
              </div>
            </div>)}
        </motion.div>}
    </div>;
}